
const state = {
  show: false,
  shareInfo: {}
}

const actions = {
  updateShare (ctx, item) {
    ctx.commit('updateShare', item)
  }
}

const mutations = {
  updateShare (state, item) {
    state.shareInfo = item
  },
  showAddShare (state, item) {
    state.show = item
  }
}

export default{
  namespaced: true,
  state,
  actions,
  mutations
}
